<header>
  <nav class="navbar">
    <div class="container-left">
       <div class="logo-area">
        <img
          src="assets/gafiLogo.png"
          alt="GAFI Logo"
          class="logo"
          (click)="navigateToHome()"
        />
      </div>

      <!-- Hamburger Menu Button (Mobile Only) -->
      <button class="hamburger-btn" (click)="toggleMenu()" [class.active]="isMenuOpen">
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
      </button>

      <!-- Navigation Links -->
      <div class="nav-links" [class.show-menu]="isMenuOpen">
        <!-- Close Button for Mobile Menu -->
        <button class="close-menu-btn" (click)="closeMenu()">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <ul class="main-menu">
          <li class="menu-item dropdown hover-dropdown">
            <a class="menu-link" href="{{ isEnabledGafiRedirect ?  'https://gafi.gov.eg' : '/home'}}">
              الصفحة الرئيسيه
              <!-- <span class="dropdown-indicator">▼</span> -->
            </a>
            <!-- <div class="dropdown-menu" [class.show]="activeSubmenu === 0">
              <a class="dropdown-item" href="/whyEgypt" (click)="closeMenu()">عن مصر</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/indicators" (click)="closeMenu()">أهم المؤشرات الاقتصادية</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/success" (click)="closeMenu()">قصص النجاح</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/develpment" (click)="closeMenu()">بنية حديثة و مطورة</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/youth" (click)="closeMenu()">الشباب والابتكار</a>
            </div> -->
          </li>
          <li class="menu-item">
            <a class="menu-link" href="/services/main-services">
              الخدمات الالكترونيه
            </a>
          </li>
<!-- 
          <li class="menu-item">
            <a class="menu-link" href="#" (click)="closeMenu()">الخريطة الاستثمارية</a>
          </li>

          <li class="menu-item dropdown hover-dropdown">
            <a class="menu-link" href="/goahead" (click)="toggleSubmenu($event, 1)">
              انطلق
              <span class="dropdown-indicator">▼</span>
            </a>
            <div class="dropdown-menu" [class.show]="activeSubmenu === 1">
              <a class="dropdown-item" href="/investment-systems" (click)="closeMenu()">الأنظمة الاستثمارية</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/business-rules" (click)="closeMenu()">الحقائق التجارية</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/regulations-and-rules" (click)="closeMenu()">القوانين واللوائح</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/suggested-sites" (click)="closeMenu()">مواقع مقترحة</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/investor-guide" (click)="closeMenu()">دليل المستثمر</a>
            </div>
          </li>

          <li class="menu-item dropdown hover-dropdown">
            <a class="menu-link" href="/investmentSectors" (click)="toggleSubmenu($event, 2)">
              قطاعات الإستثمار
              <span class="dropdown-indicator">▼</span>
            </a>
            <div class="dropdown-menu" [class.show]="activeSubmenu === 2">
              <a class="dropdown-item" href="/economicPerformance" (click)="closeMenu()">القطاعات المستهدفة</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/agreements" (click)="closeMenu()">الإتفاقيات التجارية</a>
            </div>
          </li>

          <li class="menu-item dropdown hover-dropdown">
            <a class="menu-link" href="/help" (click)="toggleSubmenu($event, 3)">
              كيف يمكننا أن نساعد
              <span class="dropdown-indicator">▼</span>
            </a>
            <div class="dropdown-menu" [class.show]="activeSubmenu === 3">
              <a class="dropdown-item" href="/InvestorsCenterComponent" (click)="closeMenu()">مركز خدمات المستثمرين</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/InvestorsAgentsComponent" (click)="closeMenu()">مركز شئون وكلاء المستثمرين</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/InvestorsDisputeComponent" (click)="closeMenu()">مركز تسوية منازعات المستثمرين</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/FrequentlyAskedQuestionsComponent" (click)="closeMenu()">الأسئلة الشائعة</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/SocialResponsibilityComponent" (click)="closeMenu()">المسئولية المجتمعية للشركات</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/CareEgyptianInvestorsComponent" (click)="closeMenu()">وحدة رعاية المستثمرين المصريين
                بالخارج</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/EconomicperformanceHelpComponent" (click)="closeMenu()">الأداء الاقتصادي</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/EgyptianCitizenshipComponent" (click)="closeMenu()">منح الجنسية مقابل الاستثمار</a>
            </div>
          </li>

          <li class="menu-item dropdown hover-dropdown">
            <a class="menu-link" href="/mediacenter" (click)="toggleSubmenu($event, 4)">
              المركز الإعلامي
              <span class="dropdown-indicator">▼</span>
            </a>
            <div class="dropdown-menu" [class.show]="activeSubmenu === 4">
              <a class="dropdown-item" href="/medianews" (click)="closeMenu()">الأخبار</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/mediaActions" (click)="closeMenu()">الأحداث</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/mediaVideos" (click)="closeMenu()">معرض الفيديو</a>
            </div>
          </li>

          <li class="menu-item dropdown hover-dropdown">
            <a class="menu-link" (click)="toggleSubmenu($event, 5)">
              الخدمات الإلكترونية
              <span class="dropdown-indicator">▼</span>
            </a>
            <div class="dropdown-menu" [class.show]="activeSubmenu === 5">
              <a class="dropdown-item" href="/allServices" (click)="closeMenu()">جميع الخدمات</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/services/premission" (click)="closeMenu()">صلاحية التعامل على الشركات</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/services/eServices" (click)="closeMenu()">التأسيس الإلكتروني</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/investmentReport" (click)="closeMenu()">تقارير الاستثمار الأجنبي المباشر</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" (click)="startSso(); closeMenu()" style="cursor: pointer;">خدمات المناطق الحرة</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/compliments" (click)="closeMenu()">الشكاوى</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/goldenPermission" (click)="closeMenu()">الرخصة الذهبية</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/evaluation" (click)="closeMenu()">تقييم خدمات الهيئة</a>
            </div>
          </li> -->
        </ul>

        <!-- User Section for Mobile -->
        <div class="container-right-mobile">
          <ul class="mobile-user-menu">
            <li class="menu-item dropdown hover-dropdown" *ngIf="isAuthenticated">
              <a class="menu-link" (click)="toggleSubmenu($event, 6)">
                <div class="welcome-user-wrapper">
                  <i class="fa-solid fa-circle-user icon-space" style="font-size:20px;color:#fff;"></i>
                  <p class="welcome-txt font-16">مرحبا,</p>
                  <span class="font-16 username">{{ getFullName() }}</span>
                  <span class="dropdown-indicator">▼</span>
                </div>
              </a>
              <div class="dropdown-menu" [class.show]="activeSubmenu === 6">
                <a class="dropdown-item" routerLink="/workspace/profile">
                  <i class="fa-solid fa-user-pen icon-space"></i>
                  تعديل البيانات الشخصية
                </a>
                <a class="dropdown-item" href="/workspace">
                  <i class="fa-solid fa-briefcase-medical icon-space"></i>مساحة العمل
                </a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#" (click)="closeMenu()"><i class="fa-solid fa-language icon-space"></i>English</a>
                <a class="dropdown-item" *ngIf="canViewFreeZones" (click)="goToFreeZones()" target="_blank">خدمات المناطق الحرة</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item logout-item" (click)="logout(); closeMenu()" style="cursor:pointer;">
                  <i class="fa-solid fa-arrow-right-from-bracket icon-space"></i>تسجيل الخروج
                </a>
              </div>
            </li>

            <ng-container *ngIf="!isAuthenticated">
              <li>
                <a href="/auth/login" class="nav-link a-style" (click)="closeMenu()">
                  <i class="fa-solid fa-right-to-bracket ms-2"></i>تسجيل الدخول
                </a>
              </li>
              <li>
                <a href="/auth/register" class="nav-link a-style" (click)="closeMenu()">
                  <i class="fa-solid fa-user-plus ms-2"></i>مستخدم جديد
                </a>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>

    <!-- Desktop User Section -->
    <div class="container-right">
      <ul class="desktop-user-menu">
        <li class="menu-item dropdown hover-dropdown" *ngIf="isAuthenticated">
          <a class="menu-link">
            <div class="welcome-user-wrapper">
              <i class="fa-solid fa-circle-user icon-space" style="font-size:20px;color:#fff;"></i>
              <p class="welcome-txt font-16">مرحبا,</p>
              <span class="font-16 username">{{ getFullName() }}</span>
              <span class="dropdown-indicator">▼</span>
            </div>
          </a>
          <div class="dropdown-menu">
            <a class="dropdown-item" routerLink="/workspace/profile">
              <i class="fa-solid fa-user-pen icon-space"></i>
              تعديل البيانات الشخصية
            </a> <a class="dropdown-item" href="/workspace">
              <i class="fa-solid fa-briefcase-medical icon-space"></i>مساحة العمل
            </a>
            <!-- <a class="dropdown-item" *ngIf="canViewFreeZones" (click)="goToFreeZones()" target="_blank">خدمات المناطق الحرة</a> -->
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#"><i class="fa-solid fa-language icon-space"></i>English</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item logout-item" (click)="logout()" style="cursor:pointer;">
              <i class="fa-solid fa-arrow-right-from-bracket icon-space"></i>تسجيل الخروج
            </a>
          </div>
        </li>
      </ul>

      <ng-container *ngIf="!isAuthenticated">
        <a href="/auth/login" class="nav-link a-style">
          <i class="fa-solid fa-right-to-bracket ms-2"></i>تسجيل الدخول
        </a>
        <a href="/auth/register" class="nav-link a-style">
          <i class="fa-solid fa-user-plus ms-2"></i>مستخدم جديد
        </a>
      </ng-container>
    </div>
  </nav>
</header>